<template>
  <v-autocomplete
    v-model="selectedPremise"
    :items="premisesWithFreeSeats"
    :item-title="() => ''"
    item-value="shortPrem"
    label="Gebäude/Etage"
    density="compact"
    variant="solo"
    class="dropDownMenu"
    hide-details
    return-object
  >
    <!-- Dropdown-Einträge -->
    <template #item="{ props, item }">
      <v-list-item v-bind="props">
        <div class="item-row">
          <span class="item-name">{{ item.raw.name }}</span>
          <strong
            :class="{
              'text-free': item.raw.freeCount > 0,
              'text-none': item.raw.freeCount === 0
            }"
          >
            - {{ item.raw.freeCount }} Plätze frei
          </strong>
        </div>
      </v-list-item>
    </template>

    <!-- Anzeige im Eingabefeld -->
    <template #selection="{ item }">
      <div v-if="item" class="item-row">
        <span class="item-name">{{ item.raw.name }} </span>
        <strong
          :class="{
            'text-free': item.raw.freeCount > 0,
            'text-none': item.raw.freeCount === 0
          }"
        >
        - {{ item.raw.freeCount }} Plätze frei
        </strong>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    modelValue: { type: Object, default: null },
    dropDownPremisesSeats: { type: Array, default: () => [] },
    dropDownPremises: { type: Array, default: () => [] },
  },

  emits: ['update:modelValue'],

  data() {
    return { selectedPremise: this.modelValue }
  },

  computed: {
    freeSeatCounts() {
      const counts = {}
      for (const seat of this.dropDownPremisesSeats) {
        const key = seat.locationPath
        if (!counts[key]) counts[key] = 0
        if (!seat.fully_booked && !seat.partial_booked) counts[key]++
      }
      return counts
    },

    premisesWithFreeSeats() {  
      return this.dropDownPremises.map(p => ({
        ...p,
        freeCount: this.freeSeatCounts[p.shortPrem] || 0,
      }))
    },
  },

  watch: {
    dropDownPremisesSeats: {
      handler() {
        this.initDefaultSelection()
      },
      deep: true
    },
    dropDownPremises: {
      handler() {
        this.initDefaultSelection()
      },
      deep: true,
      immediate: true
    },
    selectedPremise(val) {
      this.$emit('update:modelValue', val)
    },
    modelValue(val) {
      this.selectedPremise = val
    },
  },

  methods: {
    initDefaultSelection() {
      // beide müssen geladen sein
      if (!this.dropDownPremises.length) return
      if (!this.dropDownPremisesSeats.length) return

      // freeCount vorhanden (wichtig!)
      if (!this.premisesWithFreeSeats.length) return

      // NICHT überschreiben, wenn User schon etwas gewählt hat
      if (this.selectedPremise) return

      const first = this.premisesWithFreeSeats[0]
      if (!first) return

      this.selectedPremise = first
      this.$emit('update:modelValue', first)
    }
  }
}
</script>

<style scoped>
.v-autocomplete {
  justify-content: space-between;
  color: black;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
  font-size: small;
  border-radius: 4px;
  min-width: 0 !important;
}
.item-row {
  justify-content: space-between;
  align-items: center;
}
/* Linker Text */
.item-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Stil für (x frei) */
.text-free {
  color: #00b109;
  font-weight: bold;
}

/* Stil für (0 frei) */
.text-none {
  color: #ff0000;
  font-weight: bold;
}
</style>
